import { useMemo } from 'react';

const useProfessionRows = (professions) =>
	useMemo(
		() => [...professions]
			.sort((a, b) => a.title.localeCompare(b.title))
			.map(p => ({ id: p.id, label: p.title })),
		[professions]
	);

export default useProfessionRows;
